import React from "react";
import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="cacGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#0E5A72" />
        <stop offset="60%" stopColor="#14708C" />
        <stop offset="100%" stopColor="#1B8A80" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="44" height="44" rx="13" fill="url(#cacGrad)" />
    <path
      d="M24 35C13.8 27.7 10.6 20.6 14.8 16.3C17.9 13.1 22 14.2 24 17.3C26 14.2 30.1 13.1 33.2 16.3C37.4 20.6 34.2 27.7 24 35Z"
      fill="#ffffff"
    />
    <path
      d="M13 24H19.5L21.7 19.2L25.2 29.2L27.2 24H35"
      fill="none"
      stroke="#2E9E6A"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Logo = ({ variant = "light" }) => {
  const nameColor = variant === "dark" ? "text-white" : "text-[#0E5A72]";
  return (
    <Link to="/" className="flex items-center gap-3">
      <LogoMark className="h-11 w-11 shadow-md rounded-[13px]" />
      <div className="leading-tight">
        <div className={`font-display font-bold text-lg ${nameColor}`}>Caregivers Alliance</div>
        <div className="text-xs tracking-[0.15em] text-[#2E9E6A] font-semibold">HOMECARE</div>
      </div>
    </Link>
  );
};

export default Logo;
